/**
 * <blog-related-slider>
 *
 * Initialises a Swiper-based "related products" slider injected into blog article
 * content. swiper-bundle.min.js is loaded globally via theme.liquid, but because
 * this element can be rendered mid-content we guard against Swiper not being ready
 * yet and wait for the bundle's load event.
 *
 * Desktop (>= 750px): 2 slides per view.
 * Mobile  (< 750px):  ~1.2 slides per view (peeks the next card).
 */
class BlogRelatedSlider extends HTMLElement {
  /** @type {import('swiper').Swiper | null} */
  #swiper = null;

  connectedCallback() {
    if (typeof Swiper !== 'undefined') {
      this.#init();
    } else {
      const swiperScript = document.querySelector('script[src*="swiper-bundle"]');
      if (swiperScript) {
        swiperScript.addEventListener('load', () => this.#init(), { once: true });
      }
    }
  }

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }

  #init() {
    if (this.#swiper) return;

    const swiperEl = this.querySelector('.blog-related-slider__swiper');
    if (!swiperEl) return;

    const prevBtn = this.querySelector('.blog-related-slider__btn--prev');
    const nextBtn = this.querySelector('.blog-related-slider__btn--next');
    const pagination = this.querySelector('.blog-related-slider__pagination');

    this.#swiper = new window.Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      a11y: false,
      watchOverflow: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'swiper-button-disabled',
      },
      pagination: {
        el: pagination,
        clickable: true,
        type: 'bullets',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
  }
}

customElements.define('blog-related-slider', BlogRelatedSlider);
